import { GlobalService } from 'src/app/services/global/global.service';
import { AlertController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate
{
  private consoleLog:boolean = false;

  constructor
   ( public router: Router
   , public alertController: AlertController
   , public translate: TranslateService
   , public globalProvider: GlobalService
   ) 
  { 
    this.consoleLog = this.globalProvider.consoleLog_authguard;
    if (this.consoleLog) console.log('AuthGuard.ctor - LifeCycle');
  }

  canActivate(route: ActivatedRouteSnapshot): boolean
  {
    if (this.consoleLog) console.log('AuthGuard.canActivate', route);
    if (this.consoleLog) console.log('AuthGuard.canActivate - route.url: ' + route.url);

    if (this.globalProvider.MobileUserProfile.ActiveLogin === true)
    {
      if (this.consoleLog) console.log('AuthGuard.canActivate: OK -- ActiveLogin -- continue to ' + route.url);
      return true;
    }

    if (this.globalProvider.OneTimeAmbitSplash !== true)
    {
      if (this.consoleLog) console.log('AuthGuard.canActivate: SPLASH NOT RUN YET -- hold off from ' + route.url);
      this.globalProvider.OneTimeAmbitSplash = true;
      this.globalProvider.OneTimeNextPage = this.SetOneTimeNextPage(route);
      this.NeedToDisplaySplashOnce();
      return false;
    }

    this.NeedToLogin();
    return false;
  }

  SetOneTimeNextPage(route: ActivatedRouteSnapshot):string
  {
    let url = '/actions';  // set a default
    if (!route)
    {
      // unexpected but handle just to be sage
      return url;  
    }

    if ((route.routeConfig) && (route.routeConfig.path))
    {
      // use the intended path
      url = route.routeConfig.path;
    }
    else if (route.url)
    {
      // alternative to get to intended path
      url = route.url.toString();
    }

    // we want to start at the root level
    if (!url.startsWith('/'))
    {
      url = '/' + url;
    }
    if (this.consoleLog) console.log("AuthGuard.SetOneTimeNextPage: " + url);
    return url;
  }

  NeedToDisplaySplashOnce()
  {
    if (this.consoleLog) console.log('AuthGuard.NeedToDisplaySplashOnce');
    this.globalProvider.NavData.Initialize("AuthGuard");
    this.router.navigateByUrl('/ambitsplash'); 
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  NeedToLogin()
  {
    if (this.consoleLog) console.log('AuthGuard.NeedToLogin');

    this.alertController.create({
      header: this.myTranslate("App Notice")
      , subHeader: this.myTranslate("Credentials Required")
      , message: this.myTranslate("Please login to continue")
      , buttons: [
        { text: this.myTranslate('OK')
        , handler: () => 
          {
            console.log('AuthGuard.NeedToLogin: route to login page');
            //this.router.navigateByUrl('/list');  
            this.globalProvider.NavData.Initialize("AuthGuard");
            this.router.navigateByUrl('/login'); 
          }
        }]
    })
    .then(alert => alert.present());
  }
}
